import { createMutation } from 'react-query-kit';

import { privateApi } from 'api';

import { SerializedEditorState } from 'lexical';
import { GetAgreementResult } from '../tenant/GetGeneralStudentAgreement';

export type UpdateCourseTermsParams = {
    courseId: string;
    data: {
        content: SerializedEditorState;
    }
};

export type UpdateCourseTermsResult = GetAgreementResult;

async function updateCourseTerms(params: UpdateCourseTermsParams): Promise<UpdateCourseTermsResult> {
    const { courseId, data } = params;

    // make api call
    const result = await privateApi.patch<UpdateCourseTermsResult>(`${import.meta.env.VITE_API_BASE_URL}/courses/${courseId}/agreement`, data);

    // return the data object
    return result.data;
}

const useUpdateCourseTerms = createMutation({
    mutationFn: async (variables: UpdateCourseTermsParams) => updateCourseTerms(variables),
});

export { updateCourseTerms, useUpdateCourseTerms };
